import React from 'react';
interface ThisProps {
}
const AddTeam: React.FC<ThisProps> = () => {

    return(<h1>AddTeam Works!</h1>);
}

export default AddTeam;
